import { status } from "./status";
import { data } from "./data";
import { caddy } from "./caddy";

export const plano = {
    namespaced: true,
    modules: {
        status,
        data,
        caddy
    }
};



// WEBPACK FOOTER //
// ./src/store/plano/plano.js